<template>
  <span>
<!--     <vs-button type="border" v-if="historicalReviewAvailable" size="small" @click="popupActive=true">Open Review for
      {{startReviewDay | date}} - {{endReviewDay | date}}
    </vs-button> -->
  <vs-button type="border" size="small" @click="popupActive=true">Open Review for last week</vs-button>
    <vs-popup fullscreen title="" :active.sync="popupActive">
      <Review :review="review" @close="popupActive=false" />
    </vs-popup>
  </span>
</template>

<script>
import * as DateHelper from '@/helpers/date'
import Review from './Review'

export default {
  components: {
    Review
  },
  props: [],
  data () {
    return {
      popupActive: false,
    }
  },
  // watch: {
  //   'reviewPopupOpen': {
  //     immediate: false,
  //     handler (reviewPopupOpen) {
  //       this.popupActive = reviewPopupOpen
  //     }
  //   },
  //   'popupActive': {
  //     immediate: false,
  //     handler (popupActive) {
  //       if (!popupActive) {

  //       }
  //     }
  //   }
  // },

  computed: {
    // newEntity () {
    //   return {
    //     from: DateHelper.thisWeek().from,
    //     to: DateHelper.thisWeek().to,
    //     // periodName: 'this week',
    //     period: 'week',
    //     reflections: [
    //       {
    //         question: 'I should start doing...',
    //         answer: ''
    //        },
    //       {
    //         question: 'I should keep doing...',
    //         answer: ''
    //        },
    //       {
    //         question: 'I should stop doing...',
    //         answer: ''
    //        },
    //     ]
    //   }
    // },
    review () {
      return this.$store.getters.getReview(DateHelper.thisWeek().to, DateHelper.thisWeek().from, 'week')

       // || this.newEntity
    }
  },

}
</script>
